module.exports = __webpack_public_path__ + "img/cancun-bay-pool-3.2c1f9291.jpg";